import { SuperAgentRequest } from 'superagent';
import { getTokenProvider } from 'config';
import { createAuthHeader } from 'token';
import { RequestConfig } from 'types';

const DEFAULT_CONFIG: RequestConfig = {
  disableAuthHeader: false,
  omitBearerPrefix: false,
};

export default function authHeaderRequestPlugin() {
  return (request: SuperAgentRequest): SuperAgentRequest => {
    const getToken = getTokenProvider();
    const token = getToken();

    const setAuthHeader = (config?: RequestConfig) => {
      const {
        accessToken: tokenOverride,
        disableAuthHeader = false,
        omitBearerPrefix = false,
      } = config ?? {};

      const accessToken = tokenOverride ?? token;

      if (disableAuthHeader || !accessToken) {
        request.unset('Authorization');
        return request;
      }

      request.set(
        'Authorization',
        createAuthHeader(accessToken, !omitBearerPrefix),
      );

      return request;
    };

    request.authHeader = setAuthHeader;

    return setAuthHeader(DEFAULT_CONFIG);
  };
}
